var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "append-to-body": "",
        "custom-class": "dialog-body",
        "show-close": false,
        "close-on-click-modal": false,
        "press-escape": false,
        top: "10vh",
        width: "700px",
        height: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "ss-material-box-header",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_c("div", [_vm._v(_vm._s(_vm.title))])]
      ),
      _c(
        "div",
        { staticClass: "OSSUpload", style: {} },
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              staticClass: "upload-demo",
              attrs: {
                accept:
                  "video/mp4,video/ogg,video/flv,video/avi,video/wmv,video/rmvb,video/mov",
                "http-request": _vm.fileChange,
                drag: "",
                action: "#",
                "show-file-list": false,
                headers: {
                  Authorization: _vm.getToken,
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("将文件拖到此处，或"),
                _c("em", [_vm._v("点击上传")]),
              ]),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [
                  _vm._v(
                    "只能上传mp4、avi、wmv、mov、flv、rmvb、3gp、m4v、mkv、webm文件，且不超过200M"
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "audioBox" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.fileList },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "文件名", width: "180" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "percent", label: "进度" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-progress", {
                              attrs: { percentage: scope.row.authProgress },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "percent", label: "状态", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(_vm.statusText[scope.row.status])),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status === 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(scope.row, scope.$index)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                            scope.row.status === 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#E6A23C" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.cancelRequest(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("取消上传")]
                                )
                              : _vm._e(),
                            scope.row.status === 4
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#E6A23C" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.againUpload(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("重新上传")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ss-material-box-bottom" },
        [
          _c("el-button", { on: { click: _vm.sure } }, [_vm._v("确定")]),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }